import { useState } from 'react'
import { FaBriefcase, FaGraduationCap, FaRocket, FaTrophy } from 'react-icons/fa';
import { Fade } from 'react-reveal';
import { jobs } from './data/jobs';
import { schools } from './data/schools';
import { trainings } from './data/trainings';
import { awards } from './data/awards';

// Components
import Accordion from '../../components/accordion/Accordion'
import Training from '../../components/training/Training'

import './qualifications.css'

const Qualifications = () => {
    const [toggleState, setToggleState] = useState(3);
    const [accordionState, setAccordionState] = useState(null);

    const toggleTab = (index) => {
        setToggleState(index);
        setAccordionState(index === 1 ? 0 : null);
    };

    const toggleAccordion = (index) => accordionState === index ? setAccordionState(null) : setAccordionState(index);

    return (
        <section className="qualifications" id="experience">
            <h2 className="qualifications_title">Experience</h2>
            <div className="tabs">
                <div className={`tabs_item ${toggleState === 2 ? "tabs_item-active" : ""}`} onClick={() => toggleTab(2)}>
                    <FaTrophy />
                    Awards
                </div>
                <div className={`tabs_item ${toggleState === 3 ? "tabs_item-active" : ""}`} onClick={() => toggleTab(3)}>
                    <FaBriefcase />
                    Career
                </div>
                <div className={`tabs_item ${toggleState === 1 ? "tabs_item-active" : ""}`} onClick={() => toggleTab(1)}>
                    <FaGraduationCap />
                    Education
                </div>
                <div className={`tabs_item ${toggleState === 4 ? "tabs_item-active" : ""}`} onClick={() => toggleTab(4)}>
                    <FaRocket />
                    Trainings
                </div>
            </div>
            <div className="qualifications_content">
                <Fade big>
                    {(() => {
                        switch (toggleState) {
                            case 1:
                                return (
                                    <>
                                        {schools.map((school, index) => (
                                            <Accordion item={school} 
                                                toggleAccordion={toggleAccordion} 
                                                index={index}
                                                toggleDetails = {accordionState === index ? true : false} /> 
                                        ))}
                                    </>
                                )
                            case 2:
                                return (
                                    <>
                                        {awards.map((award, index) => (
                                            <Training item={award} />
                                        ))}
                                    </>
                                )
                            case 3:
                                return (
                                    <>
                                        {jobs.map((job, index) => (
                                            <Training item={job} key={index} />
                                        ))}
                                    </>
                                )
                            case 4:
                                return (
                                    <>
                                        {trainings.map((training, index) => (
                                            <Training item={training} />
                                        ))}
                                    </>
                                )
                            default:
                                return null
                        }
                    })()}
                </Fade>
            </div>
        </section>
    )
}

export default Qualifications
